import React, {useEffect, useState} from "react";
import {Table, Form, Input, Select, Button, Space, Card, Row, Col, Switch, message, Modal, Popconfirm} from "antd";
import {SearchOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import styles from "./FamousTeacherManager.module.css";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

import {Pagination} from 'antd';

import CommonModal from './add/Common.js'
import EditCommonModal from './editSchool/Common.js'
import EditSchoolMemberModal from './editSchoolMember/Common.js'

import {
    getInfoListRequest,
    getRegionListRequest,
    changeAdminStatusRequest,
    deleteAdminRequest,
    changeSchoolTeacherRequest,
    deleteSchoolMemberRequest
} from "./api";
import { closeAdminPage, openLogin} from "../../../store/modalsSlice";
import settingIcon from "./setting.svg";
import {useDispatch} from "react-redux";
import InfoItem from "./InfoItem";
import { clearAllCookies } from "../../../util/handleObject.js";

const {Option} = Select;

const FamousTeacherManager = () => {

    const dispatch = useDispatch();
    // 筛选表单状态
    const [filterForm, setFilterForm] = useState({
        name: "",
        province: "未选择",
        status: "",
        shenfen:''
    });
    const [provinceList, setProvinceList] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    // 分页状态

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isShowEditCommon, setIsShowEditCommon] = useState(false);
    const [isShowEditSchoolMember, setIsShowEditSchoolMember] = useState(false);
    const [editUser, setEditUser] = useState({
        name: "",
    });
    const [totalNumber, setTotalNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageApi, contextHolder] = message.useMessage();


    const [user, setUser] = useState({
        name: "",
        email: ""
    });

    useEffect(() => {
        getProvinceList()
        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage-1)*limit, limit)
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次
    function getProvinceList() {
        getRegionListRequest("1", "", (data) => {
            console.log(data);
            console.log(data);
            var newProvinceList = [{
                quyu_name: "未选择",
                quyu_code: ""
            }];
            if (data.ret == 1) {
                data.data.forEach(element => {
                    newProvinceList.push(element)
                });
                setProvinceList(newProvinceList)
            } else if (data.ret == 99) {
                messageApi.open({
                    type: 'warning',
                    // content: data.msg,
                    content: data.msg
                });
                setTimeout((e) => {
                    sessionStorage.clear()
                    clearAllCookies()
                    window.location.reload()
                }, 1000)
            }
        })
    }

    function getUserList(namekey,province, status,shenfen, offset, limit) {
        getInfoListRequest(namekey,province=="未选择"?"":province, status,shenfen, offset, limit, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setSchoolList(data.data.data)
                setTotalNumber(data.data.total_num)
            } else {
                setSchoolList([])
                setTotalNumber(0)
            }
        });
    }

    function deleteUser(user) {
        if(user.type==2){
            deleteAdminRequest(user.username, (data) => {

                if (data.ret === '1') {
                    message.success("删除成功", 1);
                    if(currentPage > 1&&schoolList.length==1) {
                        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage - 2) * limit, limit)
                        setCurrentPage(currentPage - 1)
                    }
                    else {
                        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage - 1) * limit, limit)
                    }
                } else {
                    message.error(data.msg);
                }
            });
        }
        else if(user.type==3){
            deleteSchoolMemberRequest(user.username, (data) => {

                if (data.ret === '1') {
                    message.success("删除成功", 1);
                    getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage-1)*limit, limit)
                } else {
                    message.error(data.msg);
                }
            });
        }
    }

    function closeCommonModal() {
        setIsModalVisible(false)
        setIsShowEditCommon(false)
        setIsShowEditSchoolMember(false)
    };

    function updateData() {
        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage-1)*limit, limit)
    }

    // 处理状态切换
    const handleStatusChange = (info, checked) => {
        var status = checked ? '1' : '3';
        var username = info.username;
        if(info.type==2){
            changeAdminStatusRequest(username, status, (data) => {
                if (data.ret === '1') {
                    setSchoolList(schoolList.map(user =>
                        user.username === username ? {...user, status: checked} : user
                    ));
                } else {
                    message.error(data.msg, 1);
                }
            });
        }
        else {
            changeSchoolTeacherRequest(username, status, (data) => {
                if (data.ret === '1') {
                    setSchoolList(schoolList.map(user =>
                        user.username === username ? {...user, status: checked} : user
                    ));
                } else {
                    message.error(data.msg, 1);
                }
            });
        }



    };

    // 处理删除操作
    const handleDelete = (info) => {
        console.log(info);
        var content =""
        if(info.type==2){
            content = "确定要删除学校管理员账号"+info.user_login+"吗，删除后不可恢复？"
        }
        else if(info.type==3){
            content = "确定要删除学校成员账号"+info.user_login+"吗，删除后不可恢复？"
        }
        Modal.confirm({
            title: '确认删除',
            // content: '确定要删除账号' + info.user_login + '吗？删除后不可恢复',
            content: content,
            okText: '确定',
            // okType: 'danger',
            cancelText: '取消',
            onOk() {
                console.log('用户点击了确定');
                // 在这里调用删除API
                deleteUser(info)
            },
            onCancel() {
                console.log('用户点击了取消');
            },
        });
    };


    // 处理筛选表单变化
    const handleFilterChange = (name, value) => {
        console.log(name);
        console.log("=============================")
        console.log(value)
        setFilterForm({
            ...filterForm,
            [name]: value
        });
    };

    // 处理筛选提交
    const handleFilterSubmit = () => {
        setCurrentPage(1)
        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, 0, limit)

    };

    // 处理重置筛选
    const handleResetFilter = () => {
        setFilterForm({
            name: "",
            province: "未选择",
            status: "",
            shenfen:""
        });
        setCurrentPage(1)
        // 重置后重新获取所有数据
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        setCurrentPage(current)
        getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (current - 1) * pageSize, pageSize)

    };


    return (

        <div className={styles.background}>
            {contextHolder}
            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>名师信息管理</h3>

                    <Popconfirm
                        placement="bottom"
                        title={""}
                        description={"是否退出登录"}
                        okText="是"
                        cancelText="否"
                        onConfirm={(e) => {
                            sessionStorage.clear()
                            clearAllCookies()
                            dispatch(closeAdminPage())
                            dispatch(openLogin())
                        }}
                    >
                        <div className={styles.iconContainer}>
                            <img src={settingIcon} style={{width: '20px', height: '20px'}}/>
                        </div>
                    </Popconfirm>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={(e)=>{
                            getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage - 1) * limit, limit)
                        }}
                    >
                        刷新
                    </Button>
                </div>


                <Card title="" className={styles["card-top"]}>

                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={handleResetFilter}>重置</Button>
                            <Button
                                type="primary"
                                onClick={handleFilterSubmit}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={24} align="middle">
                        <Col>
                            <Row align="middle">
                                <Col flex="50px"
                                >
                                    关键字
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                >
                                    <Input
                                        placeholder="关键字"
                                        value={filterForm.name}
                                        onChange={(e) => handleFilterChange("name", e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col >
                            <Row align="middle">
                                <Col flex="40px"
                                >
                                    状态
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                    justify="start"
                                >
                                    <Select
                                        style={{minWidth: "88px"}}
                                        placeholder="状态"
                                        value={filterForm.status}
                                        onChange={(value) => handleFilterChange("status", value)}
                                    >
                                        <Option value="">全部</Option>
                                        <Option value="1">正常</Option>
                                        <Option value="3">禁用</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                            <Button
                                style={{marginLeft: 'auto'}}
                                type="primary"
                                onClick={() => {
                                    setIsModalVisible(true)
                                }}
                            >
                                添加
                            </Button>

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >教师姓名
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >教学视频
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >精选课件
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >状态
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >添加时间
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作
                                    </td>
                                </tr>
                                {schoolList.map((item, index) => (
                                    <InfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                        editMethod={(info) => {
                                            console.log(info)
                                            if(info.type == 2){
                                                setEditUser(info)
                                                setIsShowEditCommon(true)
                                            }
                                            else {
                                                setEditUser(info)
                                                setIsShowEditSchoolMember(true)
                                            }
                                        }}
                                        deleteMethod={(info) => {
                                            handleDelete(info)
                                        }}
                                        changeStatus={(info,checked) => {
                                            handleStatusChange(info,checked)
                                        }}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <Pagination
                            hideOnSinglePage={false}//只有一页隐藏分页器
                            align="end"
                            style={{marginTop: 20}}
                            showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                            onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                            defaultCurrent={1}
                            current={currentPage}
                            total={totalNumber}
                            locale={{
                                items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                            }}
                            pageSizeOptions={['10', '20', '30']} // 自定义选项值
                            pageSize={limit}
                            onChange={onChangePage}
                            showLessItems={false} // 关闭"简化显示"模式
                        />
                    </div>
                </Card>
            </div>

            <CommonModal
                updateData={updateData}
                openStatus = {isModalVisible}
                closeCommonModal={closeCommonModal}
                refreshList={(e)=>{
                    setFilterForm({
                        name: '',
                        province: '未选择',
                        status: '',
                        shenfen:''
                    })
                    setCurrentPage(1)
                    getUserList("","","","", 0, limit)
                }}
            />
            {isShowEditCommon?<EditCommonModal
                user={editUser}
                updateData={updateData}
                closeCommonModal={closeCommonModal}
                openStatus = {isShowEditCommon}
                refreshList={(e)=>{
                    getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen,(currentPage-1)*limit, limit)
                }}
            />:null}
            {isShowEditSchoolMember?<EditSchoolMemberModal
                user={editUser}
                updateData={updateData}
                closeCommonModal={closeCommonModal}
                openStatus = {isShowEditSchoolMember}
                refreshList={(e)=>{
                    getUserList(filterForm.name,filterForm.province, filterForm.status, filterForm.shenfen, (currentPage-1)*limit, limit)
                }}
            />:null}


        </div>
    );
};

export default FamousTeacherManager;
